import { render, staticRenderFns } from "./estadisticas-situacion-empresa-lista.vue?vue&type=template&id=0d0235be&scoped=true&"
import script from "./estadisticas-situacion-empresa-lista.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-situacion-empresa-lista.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-situacion-empresa-lista.vue?vue&type=style&index=0&id=0d0235be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0235be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
